"use client"

import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import actionTypes from "../../../constants/actionTypes"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import { useNavigate } from "react-router-dom"
import "../../../resources/scss/videos.scss"

function SermonVideos() {
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const youtubeList = useSelector((state) => state.youtube.youtubeData)
    const isYoutube = useSelector((state) => state.youtube.isYoutube)

    const [selectedCategoryId, setSelectedCategoryId] = useState(null)
    const [youtubeListData, setYoutubeListData] = useState({})
    const [filteredVideos, setFilteredVideos] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    const [visibleCount, setVisibleCount] = useState(6)
    const [isInitialized, setIsInitialized] = useState(false)

    // 유튜브 ID 목록
    const youtubeIds = [
        "PLcGden08y5zbbwUqGPiZWpkhw01chku--",
        "PLcGden08y5zan6QomFlL0moh7SPQDit_a",
        "PLcGden08y5zZWrxWkJZzj6sB_HMdq2yI5",
        "PLcGden08y5zaIoKGu9APzjFk_c65ghRlM",
        "PLcGden08y5zaHWsZKvgUuM5o09Tss0yiF",
        "PLcGden08y5za1UeF80MIwpjsdmz-ifOBI",
    ]

    // 컴포넌트 마운트 시 즉시 초기화
    useEffect(() => {

        // 즉시 초기화 시작
        setIsInitialized(true)

        // 각 유튜브 ID에 대해 데이터 로드 요청
        youtubeIds.forEach((id) => {
            dispatch({
                type: actionTypes.YOUTUBE_ON,
                payload: {
                    projectId: 1,
                    youtubeListId: id,
                    limit: 100,
                },
            })
        })

        // 초기 카테고리 설정
        const initialCategory = location.state?.selectedCategory
        if (initialCategory && youtubeIds.includes(initialCategory)) {
            setSelectedCategoryId(initialCategory)
            if (youtubeList[initialCategory]) {
                setYoutubeListData(youtubeList[initialCategory])
                setFilteredVideos(youtubeList[initialCategory].list || [])
            }
        } else {
            // 기본적으로 첫 번째 카테고리 선택
            setSelectedCategoryId(youtubeIds[0])
            if (youtubeList[youtubeIds[0]]) {
                setYoutubeListData(youtubeList[youtubeIds[0]])
                setFilteredVideos(youtubeList[youtubeIds[0]].list || [])
            }
        }
    }, [dispatch, location.pathname]) // location.pathname을 의존성에 추가

    // 데이터 변경 감지 및 업데이트
    useEffect(() => {
        if (!isInitialized) return


        // 선택된 카테고리의 데이터가 로드되었는지 확인
        if (selectedCategoryId && youtubeList[selectedCategoryId]) {
            setYoutubeListData(youtubeList[selectedCategoryId])
            setFilteredVideos(youtubeList[selectedCategoryId].list || [])
        }

        // 메뉴 활성화
        if (selectedCategoryId) {
            setTimeout(() => {
                const element = document.getElementById(selectedCategoryId)
                if (element) {
                    const parentElement = element.parentElement
                    if (parentElement) {
                        Array.from(parentElement.children).forEach((child) => {
                            child.className = "sub-menu"
                        })
                        element.className = "sub-menu-active"
                    }
                }
            }, 100)
        }
    }, [youtubeList, selectedCategoryId, isInitialized])

    // 검색 필터링
    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredVideos(youtubeListData?.list || [])
        } else {
            setFilteredVideos(
                youtubeListData?.list?.filter(
                    (video) =>
                        video.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        String(video.subTitle || "")
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()),
                ) || [],
            )
        }
    }, [searchQuery, youtubeListData])

    function clickEventHandler(youtubeId, youtubeObjectId) {
        navigate("/video/" + youtubeId + "/" + youtubeObjectId)
    }

    function clickMenuEventHandler(id) {

        const element = document.getElementById(id)
        if (element) {
            const parentElement = element.parentElement
            if (parentElement) {
                Array.from(parentElement.children).forEach((child) => {
                    child.className = "sub-menu"
                })
                element.className = "sub-menu-active"
            }
        }

        setSelectedCategoryId(id)
        if (youtubeList[id]) {
            setYoutubeListData(youtubeList[id])
            setFilteredVideos(youtubeList[id].list || [])
        }
        setVisibleCount(6)
        setSearchQuery("")
    }

    const renderVideoSection = () => (
        <section className="playList">
            <div className="background">
                <div className="search-container">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="검색어를 입력하세요..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                <div className="layout">
                    {filteredVideos.length > 0 ? (
                        filteredVideos.slice(0, visibleCount).map((data, index) => (
                            <div
                                className="video"
                                key={data?.id || index}
                                onClick={() => clickEventHandler(youtubeListData?.youtubeId, data?.url)}
                            >
                                <div>
                                    <img
                                        width="100%"
                                        height="250px"
                                        src={data.imgUrl || "/placeholder.svg"}
                                        alt={data.title}
                                        onError={(e) => {
                                            e.target.src = "/placeholder.svg"
                                        }}
                                    />
                                    <div className="youtube-title">{data.title}</div>
                                    <div className="youtube-subTitle">
                                        {data.subTitle ? data.subTitle + " | " : ""}
                                        {data.updateTime}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div
                            style={{
                                textAlign: "center",
                                padding: "60px 20px",
                                color: "#666",
                                minHeight: "300px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    border: "3px solid #e3e3e3",
                                    borderTop: "3px solid #007bff",
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite",
                                    marginBottom: "20px",
                                }}
                            ></div>
                            <h3>영상을 불러오는 중입니다...</h3>
                            <p>잠시만 기다려주세요.</p>
                            <style jsx>{`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
                        </div>
                    )}
                </div>

                {visibleCount < filteredVideos.length && (
                    <div className="load-more">
                        <button onClick={() => setVisibleCount(visibleCount + 6)}>더보기</button>
                    </div>
                )}
            </div>
        </section>
    )

    // 초기화되지 않았으면 로딩 화면
    if (!isInitialized) {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f8f9fa",
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <div
                        style={{
                            width: "50px",
                            height: "50px",
                            border: "4px solid #e3e3e3",
                            borderTop: "4px solid #007bff",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                            margin: "0 auto 20px",
                        }}
                    ></div>
                    <h3>페이지를 준비하는 중입니다...</h3>
                    <style jsx>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
                </div>
            </div>
        )
    }

    return (
        <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
            <section className="pf-page">
                {/* 메뉴 섹션 */}
                <section className="menu-info">
                    <div className="background">
                        <div className="layout">
                            {youtubeIds.map((id, index) => (
                                <div
                                    id={id}
                                    key={id}
                                    className={selectedCategoryId === id ? "sub-menu-active" : "sub-menu"}
                                    onClick={() => clickMenuEventHandler(id)}
                                >
                                    {youtubeList[id]?.name || `카테고리 ${index + 1}`}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* 비디오 섹션 */}
                <PC>{renderVideoSection()}</PC>
                <Notebook>{renderVideoSection()}</Notebook>
                <Tablet>{renderVideoSection()}</Tablet>
                <Mobile>{renderVideoSection()}</Mobile>
            </section>
        </div>
    )
}

export default SermonVideos
